<template>
  <span>
  <v-menu v-model="dialog.open"
  :close-on-content-click="false" v-if="documentFile.storePath === '' || documentFile.storePath === null">
    <v-btn @click.native="addFile" round color="primary" slot="activator"
    >
      {{documentFile.addTitle}}
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline primary--text">{{documentFile.addTitle}}</span>
      </v-card-title>
      <v-card-text>
        <input @change="tmpUploadFile" type="file" ref="fileUploadButton" accept="application/pdf, application/vnd.apple.pages, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outline round @click.native="dialog.open = false">Close</v-btn>
        <v-btn color="primary" round @click.native="saveFile" :loading="loading" :disabled="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
  <template v-else>
    <v-btn @click.native="downloadDocument" color="primary" round outline>
      {{documentFile.downloadTitle}}
    </v-btn>
    <v-menu v-model="dialog.open"
      :close-on-content-click="false">
      <v-btn color="primary" flat icon @click.native="addFile" slot="activator">
        <v-icon>edit</v-icon>
      </v-btn>
      <v-card>
        <v-card-title>
          <span class="headline primary--text">{{documentFile.addTitle}}</span>
        </v-card-title>
        <v-card-text>
          <input @change="tmpUploadFile" type="file" ref="fileUploadButton" accept="application/pdf, application/vnd.apple.pages, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline round @click.native="dialog.open = false">Close</v-btn>
          <v-btn color="primary" round @click.native="saveFile" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </template>
</span>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  name: 'DocumentUploadCard',
  props: ['documentType'],
  data () {
    return {
      dialog: {
        open: false
      },
      fileToSend: null
    }
  },
  mounted () {
    if (this.documentType === 'resume') {
      Store.dispatch('profile/getProfile')
    }
  },
  computed: {
    ...mapState('profile', {
      loading: 'loading'
    }),
    documentFile () {
      if (this.documentType === 'resume') {
        return {
          addTitle: 'Add Resume',
          cardTitle: 'Resume',
          storePath: Store.state.profile.profile.resumePrivateUrl,
          downloadTitle: 'Download Resume',
          showCard: false
        }
      } else if (this.documentType === 'courseoutline') {
        return {
          addTitle: 'Add new Course Outline',
          cardTitle: 'CourseOutline',
          storePath: Store.state.profile.trainerPackage.outlineDocument,
          downloadTitle: 'Download Course Outline',
          showCard: false
        }
      }
    }
  },
  methods: {
    tmpUploadFile (event) {
      const files = event.target.files
      if (files.length === 0) {
        this.fileToSend = null
        this.$refs.fileUploadButton.value = ''
        return
      }
      this.fileToSend = files[0]
    },
    addFile () {
      this.fileToSend = null
      this.$refs.fileUploadButton.value = ''
    },
    cb () {
      this.dialog.open = false
    },
    async saveFile () {
      if (this.documentType === 'resume') {
        Store.dispatch('profile/uploadDocument', {data: this.fileToSend, type: 'resume', cb: this.cb})
        .then(res => {
          console.log('dispatch complete')
        })
      } else if (this.documentType === 'courseoutline') {
        Store.dispatch('profile/uploadDocument', {data: this.fileToSend, type: 'courseoutline', cb: this.cb})
        .then(res => {
          console.log('dispatch complete')
          this.dialog.open = false
        })
      }
    },
    downloadDocument () {
      Store.dispatch('profile/downloadDocument', this.documentFile.storePath)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DocumentUploadCard.vue